import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn } from 'telia-front-react';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import CalculatorCard from './card/CalculatorCard';
import { ProductCard } from './InternetCalculatorInterfaces';
import { addSpecialRequestCardWhenNecessary } from './InternetSpeedUtil';

interface Props {
  calculatorKey: string;
  partner: boolean;
  isRecommendedInternet: (productOfferingCode: string) => boolean;
  internetCalculatorStore?: InternetCalculatorStore;
}

@observer
class InternetCardsMobileGrid extends React.Component<Props> {
  public render() {
    const { internetCalculatorStore, calculatorKey, partner, isRecommendedInternet } = this.props;
    const calculatorState = internetCalculatorStore.getState(calculatorKey);
    const selectedAddress = calculatorState.address;
    const selectedRoom = calculatorState.room;
    const internetSpeeds = partner ? internetCalculatorStore.partnerProducts(calculatorKey) : internetCalculatorStore.teliaProducts(calculatorKey);
    addSpecialRequestCardWhenNecessary(internetSpeeds, calculatorState.propState.specialRequestFormName, calculatorState.propState.segment);

    return (
      <Grid equalHeight={true} align={['center-xs']}>
        {internetSpeeds?.map((card: ProductCard, idx: number) => (
          <GridColumn key={`${partner}_grid_${idx}`} width={['xs-12']}>
            <CalculatorCard
              calculatorKey={calculatorKey}
              segment={calculatorState.propState.segment}
              hideBetterInternetForms={calculatorState.propState.hideBetterInternetForms}
              card={card}
              partner={partner}
              key={card.uid}
              selectedRoom={selectedRoom}
              selectedAddress={selectedAddress}
              isRecommended={isRecommendedInternet(card.productOfferingCode)}
              specialRequestFormName={calculatorState.propState.specialRequestFormName}
              noEmptySpaceOnTop={true}
            />
          </GridColumn>
        ))}
      </Grid>
    );
  }
}

export default inject('internetCalculatorStore')(InternetCardsMobileGrid);
